import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import React from 'react';
import Button from '../Button';
import { ISearchButton } from './interface';

function SearchButton(props: ISearchButton) {
  return (
    <Button.Default
      justifyContent={props.justifyContent}
      flexDirection={props.flexDirection}
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      height={props.height}
      width={props.width}
      disabled={props.disabled}
      margin={props.margin}>
      {props.children}
      {props.disabled ? (
        <CircularProgress
          style={{ marginRight: '5px' }}
          color="inherit"
          size={16}
        />
      ) : (
        <SearchIcon />
      )}
    </Button.Default>
  );
}

export function Download(props: ISearchButton) {
  return (
    <Button.Default
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      height={props.height}
      disabled={props.disabled}
      width={props.width}>
      Download
    </Button.Default>
  );
}

export function DownloadReport(props: ISearchButton) {
  return (
    <Button.Default
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      height={props.height}
      disabled={props.disabled}
      width={props.width}>
      Gerar relatório
    </Button.Default>
  );
}

export function Loading(props: ISearchButton) {
  return (
    <Button.Default
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      height={props.height}
      disabled={props.disabled}
      width={props.width}>
      <CircularProgress
        style={{ marginRight: '5px' }}
        color="inherit"
        size={16}
      />
      Aguarde
    </Button.Default>
  );
}

export default SearchButton;
